import GiftingPlatforms from "../../components/best/GiftingPlatforms";

export { Page }

function Page() {
  return <GiftingPlatforms />;
}